import { IInitialState } from './interfaces/state';
import produce from 'immer';
import {
    CHANGE_CAPACITY,
    CHANGE_COLOR,
    SET_ATOMIC_ID,
} from './constants';
import { OptionsAction } from './actions';

/**
 * Initial state
 */
export const initialState: IInitialState = {
    currentColor: null,
    currentCapacity: null,
    atomicId: null,
    forceRerender: true,
};

/**
 * Hardware detail reducer
 * @param state
 * @param action
 */
const optionsReducer = (state: IInitialState = initialState, action: OptionsAction) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case CHANGE_COLOR:
                draft.currentColor = action.value;
                break;
            case CHANGE_CAPACITY:
                draft.currentCapacity = action.value;
                break;
            case SET_ATOMIC_ID:
                draft.atomicId = action.atomicId;
                draft.forceRerender = action.forceRerender;
                break;
        }
    });

export default optionsReducer;
